import { PropsWithChildren } from "react";
import { chakra, HTMLChakraProps } from "@chakra-ui/react";

export function LinkButton(
  props: PropsWithChildren<HTMLChakraProps<"button">>,
) {
  return (
    <chakra.button
      type="button"
      textDecoration="underline"
      display="inline-block"
      cursor={props.disabled ? "default" : "pointer"}
      color={props.disabled ? "brand.neutral.dark" : "brand.blue.primary"}
      fontWeight="normal"
      fontSize="1rem"
      bg="transparent"
      border="0"
      padding="0"
      _hover={{
        color: props.disabled ? "brand.neutral.dark" : "brand.blue.light",
      }}
      {...props}
    />
  );
}
